import React from 'react'
import AssignmentOnQueueTableContainer from './AssignmentOnQueueTableContainer'
import AppBar from '../../components/AppBar'
import storage from '../../storage'
import BackButton from '../../components/BackButton'

export default class AssignmentOnQueueScene extends React.Component {
  handleBackScene = () => {
    if (this.props.history) this.props.history.goBack()
  }

  render() {
    const { stationName, serviceDisplayName } = storage.info()
    return (
      <div className="pt-20 px-4 md:px-8 w-full">
        <AppBar
          header="Assignment"
          subHeader={`On Queue (${stationName} - ${serviceDisplayName})`}
          hasBtnGroup
        />
        <div className="pt-4 pb-20 w-full">
          <div className="flex items-center gap-3 mb-3">
            <BackButton onClick={this.handleBackScene}>Back</BackButton>
            <h1 className="text-3xl font-semibold text-gray-900">On Queue</h1>
          </div>
          <div className="border-t border-gray-200 mb-4"></div>
          <AssignmentOnQueueTableContainer />
        </div>
      </div>
    )
  }
}
